<script setup>
    import 'bootstrap/dist/css/bootstrap.min.css'
    import 'bootstrap'
    import 'bootstrap-icons/font/bootstrap-icons.css';

    import ThemeSwitch from './components/ThemeSwitch.vue'
    import { useAuthStore } from '@/stores/authStore.js'
    import { sendLogout } from '@/connector.js'

</script>

<script>
    import { getNavigation } from '@/apicalls.js'


    export default {
        data() {
            return {
                error: null,
                loading: true,
                navItems: null
            }
        },
        created() {
            this.$watch(
                () => useAuthStore().isAuthenticated(),
                () => {
                    this.fetchData()
                },
                // fetch the data when the view is created and the data is
                // already being observed
                { immediate: true }
            )
        },
        methods: {
            fetchData() {
                this.error = this.post = null
                this.loading = true
                // replace `getPost` with your data fetching util / API wrapper
                getNavigation((err, post,) => {
                    this.loading = false
                    if (err) {
                        this.error = err.toString()
                    } else {
                        this.navItems = post
                    }
                });
            },
        },
    }
</script>

<template>
    <div v-if="loading">Loading</div>
    <div v-else-if="navItems != null">
        <header v-if="useAuthStore().isAuthenticated()">
            <nav class="navbar navbar-expand-lg bg-body-tertiary px-3 py-2 border-bottom d-print-none">
                <div class="container-fluid">
                    <router-link :to="{ name: 'index', params: {} }" class="navbar-brand d-flex">
                        <div class="bi bi-box my-auto fs-2 me-2"></div>
                        <div class="f-small-caps my-auto fs-6">Ready-2/Rent</div>
                    </router-link>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul class="navbar-nav ms-auto">
                            <li v-for="item in navItems" :key="item.url" class="nav-item">
                                <router-link :to="item.url" class="nav-link py-2 py-lg-0">
                                    <div class="d-flex align-items-center gap-3 d-lg-block text-lg-center">
                                        <div class="bi fs-4" :class="item.icon"></div>
                                        <span>{{ item.title }}</span>
                                    </div>
                                </router-link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src="/avatar.png" class="rounded-circle avatar" alt="Avatar"> {{useAuthStore().lastname}} <b class="caret"></b>
                                </a>
                                <ul class="dropdown-menu">
                                    <li><a href="#" class="dropdown-item"><i class="bi bi-person-badge"></i> Profile</a></li>
                                    <li><a href="#" class="dropdown-item"><i class="bi bi-sliders"></i> Settings</a></li>
                                    <li>

                                        <router-link :to="{ name: 'addbankaccount', params: {} }" class="dropdown-item">
                                            <i class="bi bi-sliders"></i> Add Bank Account
                                        </router-link>
                                    </li>
                                    <li>

                                        <router-link :to="{ name: 'updatebankaccount', params: {} }" class="dropdown-item">
                                            <i class="bi bi-sliders"></i> Update Bank Account
                                        </router-link>
                                    </li>
                                    <li><div class="divider dropdown-divider"></div></li>
                                    <li><a href="#" @click="sendLogout()" class="dropdown-item"><i class="bi bi-door-open"></i> Logout</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <!--<div class="px-3 py-2 border-bottom mb-3">
                <div class="container d-flex flex-wrap justify-content-center">
                    <form class="col-12 col-lg-auto mb-2 mb-lg-0 me-lg-auto" role="search">
                        <input type="search" class="form-control" placeholder="Search..." aria-label="Search">
                    </form>

                    <div class="text-end">
                        <router-link to="/login" >
                            <button type="button" class="btn btn-light text-dark me-2">Login</button>
                            <button type="button" class="btn btn-primary">Sign-up</button>
                        </router-link>
                    </div>
                </div>
            </div>-->
        </header>
    </div>

    <main>
        <div class="container-fluid py-3">
            <router-view></router-view>
        </div>
    </main>
    <footer class="my-5 d-print-none">
        <hr />
        <div class="container">
            <small>Ready-2 - &#169 {{new Date().getFullYear()}} RJC</small>
        </div>
    </footer>
    <ThemeSwitch></ThemeSwitch>
</template>
